import React from "react";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import API from "../../services/API";
import InstallationsHourlyGraph from "./components/InstallationsHourlyGraph";
import InstallationsHourlyTable from "./components/InstallationsHourlyTable";
import {Button, ButtonGroup} from "react-bootstrap";
import InstallationsHourlyForm from "./components/InstallationsHourlyForm";

class ApkInstallationsHourly extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: true,
            affidValues: [],
            subidValues: [],
            report: []
        }

        this.handleSubmitButton = this.handleSubmitButton.bind(this);
    }

    componentDidMount() {
        Promise.all([
            API.apkInstallationsHourly.get({ date: new Date().toISOString().slice(0, 10) }),
            API.TrackerAffids.get('pc')
        ]).then(([report, affidValues]) => this.setState({ report: Object.values(report), affidValues, isLoading: false }))
    }

    handleSubmitButton(filters, type) {
        this.setState({ isLoading: true })

        if(type === 'subid') {
            API.apkInstallationsHourly.getSubid(filters).then(subidValues => this.setState({ subidValues, isLoading: false }))
        } else {
            API.apkInstallationsHourly.get(filters).then(report => this.setState({ report: Object.values(report), isLoading: false }))
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="APK Installations Hourly"/>

                <InstallationsHourlyForm handleSubmitButton={this.handleSubmitButton} affidValues={this.state.affidValues} subidValues={this.state.subidValues}>
                    <InstallationsHourlyGraph data={this.state.report} />
                </InstallationsHourlyForm>

                <InstallationsHourlyTable data={this.state.report} />
            </Container>
        )
    }
}

export default ApkInstallationsHourly;


// WEBPACK FOOTER //
// ./src/scenes/ApkInstallationsHourly/index.js